export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-sv-1419b4cf.png'